/**
 * Canonical slug for unlisted asset URLs.
 * Always normalizes "&" (and encoded/HTML variants) to "and" so we never
 * create duplicate paths like `/foo-&-bar` vs `/foo-and-bar`.
 */
export const toUnlistedShareSlug = (text: string) =>
    text
        .toLowerCase()
        .trim()
        .replace(/&amp;/g, " and ")
        .replace(/%26/g, " and ")
        .replace(/＆/g, " and ")
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

const RESERVED_ROOT_SEGMENTS = new Set([
    "about",
    "alts",
    "announcement",
    "contact",
    "disclaimer",
    "doc-vault",
    "incredmoney-reports",
    "investor-relations",
    "login",
    "milestone",
    "platform",
    "policy-center",
    "portfolio",
    "privacy-policy",
    "profile",
    "refer",
    "refer-dashboard",
    "signup",
    "terms-of-use",
    "unibo",
    "unlisted-shares",
]);

export const getUnlistedShareProductPath = (productId: string, displayName?: string) => {
    const slug = displayName ? toUnlistedShareSlug(displayName) : "";
    return slug ? `/${productId}/${slug}` : `/${productId}`;
};

export const isUnlistedShareProductPath = (pathname: string) => {
    const segments = pathname.split("/").filter(Boolean);
    if (segments.length === 0 || segments.length > 2) {
        return false;
    }

    const [productId] = segments;
    if (RESERVED_ROOT_SEGMENTS.has(productId.toLowerCase())) {
        return false;
    }

    return /^[A-Za-z0-9]+$/.test(productId);
};
